import { useTranslation } from 'react-i18next'
import { KeyValueTable } from '@/features/admin/components/KeyValueTable'
import { IdentityUserDto } from '@/generated/Messages/Basic_pb'

export const UserDetailsTableLayout: React.FC<
    Record<
        keyof Pick<
            IdentityUserDto,
            'firstName' | 'lastName' | 'email' | 'roles' | 'emailConfirmed'
        >,
        React.ReactNode
    >
> = ({ firstName, lastName, roles, email, emailConfirmed }) => {
    const { t } = useTranslation()

    return (
        <KeyValueTable
            rows={[
                {
                    label: t('user.firstName'),
                    value: firstName,
                },
                {
                    label: t('user.lastName'),
                    value: lastName,
                },
                { label: t('user.email'), value: email },
                {
                    label: t('user.emailConfirmed'),
                    value: emailConfirmed,
                },
                {
                    label: t('user.role'),
                    value: roles,
                },
            ]}
        />
    )
}
